const styleSheet = () => ({
  navHolder: {
    position: 'fixed',
    width: '100%',
    zIndex: 999,
  },
  nav: {
    height: '65px',
  },
  subNav: {
    height: '47px',
  },
  eab: {
    color: '#051D39 !important',
    fontSize: '24px',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
  },
  container: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
    position: 'relative',
    padding: '0 24px',
    height: '65px',
    borderBottom: '1px solid #EEF1FB',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& a': {
      color: '#051D39',
      textDecoration: 'none',
    },
  },
  listItems: {
    marginBottom: 0,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    alignItems: 'center',
    height: '100%',
    display: 'flex',
    listStyle: 'none',
    '& li': {
      height: '100%',
      display: 'flex',
      lineHeight: '70px',
      margin: '0 22px',
      padding: '0 5px',
    },
  },
  subNavContainer: {
    // position: "fixed",
    // zIndex: -1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '47px',
    borderBottom: '1px solid #EEF1FB',
    backgroundColor: '#fff',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
    '& a': {
      display: 'flex',
      color: '#085FE5',
      textDecoration: 'none',
      padding: '0 5px',
      height: '100%',
      lineHeight: '45px',
    },
    '& ul': {
      marginBottom: 0,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      listStyle: 'none',
      '& li': {
        margin: '0 15px',
        height: '100%',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '15px',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  },
  active: {
    borderBottom: '2px solid #085FE5',
    '& a': {
      color: '#085FE5',
      textDecoration: 'none',
    },
  },
  activeTop: {
    borderBottom: '3px solid #085FE5',
    '& a': {
      color: '#085FE5',
      textDecoration: 'none',
    },
  },
  inactive: {
    color: '#051D39',
  },
});

export default styleSheet;
